import { cn } from "@/utils/cn";

interface RoomButtonProps {
  className?: string;
  children: React.ReactNode;
  variant?: "active" | "inactive";
  onClick: () => void;
}

export const RoomButton: React.FC<RoomButtonProps> = ({
  className,
  children,
  variant,
  onClick,
}) => {
  const buttonClass = cn(
    "flex items-center justify-center w-[5.4rem] h-[5.4rem] border border-solid rounded shadow shadow-gray-110/25 bg-white text-[1.6rem] font-medium cursor-pointer transition-border duration-200 ease-in-out",
    className,
    {
      "border-red text-red": variant === "active",
      "border-gray text-gray-1200": variant === "inactive",
    },
  );
  return (
    <button
      className={buttonClass}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
